import { NavLink, useLocation } from "react-router-dom";
import "./sidecolumn.scss";
import { useDispatch } from "react-redux";
import { hide } from "../../redux/SideBarSlice";
import React from "react";

// components/SidebarColumn.jsx
const ChildSideColumn = ({ title, items, className, comp = "" }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  if (!items || items.length === 0) return null;
  
  const normalize = (p) => p?.replace(/\/+$/, "");

  const isActive = (path) => {
    const current = normalize(location.pathname);
    const target = normalize(path);

    return current === target || current.startsWith(target + "/");
  };

  return (
    <div className={`sidebar-column custom ${className}`}>
      <div className="custom">
        <div className="section">
          <h4>{title}</h4>

          {/* {items.map((item, id) => {
            const { text, path } = item;
            return (
              <React.Fragment key={id}>
                {comp === "product" ? (
                  <NavLink>{text}</NavLink>
                ) : (
                  <NavLink
                    onClick={() => {
                      dispatch(hide());
                    }}
                    to={path}
                  >
                    {text}
                  </NavLink>
                )}
              </React.Fragment>
            );
          })} */}

          {items.map((item, id) => {
            const { text, path } = item;
            const active = isActive(path);

            return (
              <NavLink
                key={id}
                to={path}
                className={active ? "active" : ""}
                onClick={() => dispatch(hide())}
              >
                {text}
              </NavLink>
            );
          })}
        </div>
      </div>
           {/* <div style={{border:"1px solid ", height:"400px" ,width:"400px"}}>

      </div> */}
    </div>
  );
};
export default ChildSideColumn;
